import { useCallback } from 'react';

import CheckMark from 'assets/icons/check.svg';
import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { isEnterKey } from 'utils/dom';
import { capitalize } from 'utils/string';

import s from './AnswerCheckbox.module.scss';

const cx = cn.bind(s);

function getTypeByValue(value, singleType) {
  if (value === 0) {
    return 'isNeutral';
  }
  if (singleType) {
    return `is${capitalize(singleType)}`;
  }
  if (value < 0) {
    return 'isNegative';
  }
  return 'isPositive';
}
const AnswerCheckbox = ({
  className, checked, value, singleType, onChange, ...attrs
}) => {
  const handleChange = useCallback(() => {
    onChange?.(value);
  }, [value, onChange]);
  const handleClick = useCallback(() => {
    handleChange();
  }, [handleChange]);
  const handleKeyDown = useCallback((ev) => {
    if (isEnterKey(ev)) {
      handleChange();
    }
  }, [handleChange]);
  return (
    <div
      className={cx(className, 'answer', {
        isActive: checked,
        [getTypeByValue(value, singleType)]: true,
        [`accent${Math.abs(value)}`]: value != null,
        [`size${Math.abs(value)}`]: value != null,
      })}
      tabIndex={0}
      role="checkbox"
      aria-checked={checked}
      {...attrs}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      <CheckMark className={cx('checkMark')} />
    </div>
  );
};

AnswerCheckbox.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  checked: PropTypes.bool.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  singleType: PropTypes.oneOf(['positive', 'negative', 'neutral']),
  onChange: PropTypes.func.isRequired,
};

export default AnswerCheckbox;
